/* src/app/module/users/add-user/user-personal-detail/user-personal-detail.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}
h3 {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
::ng-deep .p-col-12 {
  margin-bottom: 20px;
}
::ng-deep .p-col-12.p-md-6,
.p-col-12.p-md-4 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.custom-upload-button {
  margin-top: 33px;
  margin-bottom: 23px;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  border: 1px solid #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button:hover:not(:disabled) {
  background-color: #e67e00;
  border: 1px solid #e67e00;
  transform: translateY(-2px);
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
::ng-deep .p-highlight {
  color: #D47500;
  background: #FFF1E0;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
  margin-bottom: 4px;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .p-dropdown {
  margin-bottom: 4px;
  height: 44px;
  margin-top: 4px;
}
::ng-deep .p-inputtext {
  margin-top: 4px;
  margin-bottom: 4px;
  height: 44px;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
  font-weight: bold;
}
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  margin: 0px;
}
::ng-deep .p-dropdown span {
  margin: 0px;
}
/*# sourceMappingURL=user-personal-detail.component-XGRYPKOP.css.map */
